import React from 'react';
import FoundationSection from '../components/FoundationSection';

const WhatWeDo = () => (
  <FoundationSection
    title="Qué Hacemos: Acciones con Impacto"
    id="whatWeDo"
    imageSrc="/img7.jpg"
    imageAlt="Artesanía afrocolombiana"
    imagePosition="right"
  >
    <p className="text-center italic text-lg md:text-xl text-gray-600 mb-8">
      "En Sol Caribe desarrollamos acciones concretas para transformar vidas y fortalecer comunidades. "
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-green-50 p-6 rounded-xl shadow-md border border-green-100">
        <h3 className="text-xl md:text-2xl font-semibold text-green-700 mb-3">🧑🏽‍🏫 Desarrollo social y comunitario</h3>
        <p className="text-base md:text-lg leading-relaxed">
          Ejecutamos programas orientados a la educación, la salud, la vivienda, la infancia y el fortalecimiento del tejido social en comunidades afrocolombianas y rurales.
        </p>
      </div>
      <div className="bg-yellow-50 p-6 rounded-xl shadow-md border border-yellow-100">
        <h3 className="text-xl md:text-2xl font-semibold text-yellow-700 mb-3">💼 Emprendimiento y empleo digno</h3>
        <p className="text-base md:text-lg leading-relaxed">
          Apoyamos iniciativas productivas, formación para el trabajo, desarrollo empresarial y fortalecimiento de MiPymes para mejorar la autonomía económica de nuestras comunidades.
        </p>
      </div>
      <div className="bg-red-50 p-6 rounded-xl shadow-md border border-red-100">
        <h3 className="text-xl md:text-2xl font-semibold text-red-700 mb-3">🧒🏽 Protección de derechos y equidad</h3>
        <p className="text-base md:text-lg leading-relaxed">
          Promovemos los derechos de poblaciones vulnerables —niñez, mujeres, adultos mayores y jóvenes— garantizando su participación, inclusión y acceso a oportunidades.
        </p>
      </div>
      <div className="bg-blue-50 p-6 rounded-xl shadow-md border border-blue-100">
        <h3 className="text-xl md:text-2xl font-semibold text-blue-700 mb-3">🌿 Cuidado ambiental y sostenibilidad</h3>
        <p className="text-base md:text-lg leading-relaxed">
          Desarrollamos proyectos de conservación, educación ambiental y uso responsable de los recursos naturales, con enfoque territorial y cultural.
        </p>
      </div>
    </div>
  </FoundationSection>
);

export default WhatWeDo;